// core/api/useClientTasks.ts

import { useEffect, useState } from "react";
import { getAllProjects, ProjectAPIResponse } from "./useProject";
import { getTasksByProjectId, Tasking } from "./useTask";
import { useAuthToken } from "../data/redux/useAuthToken";

export const useClientTasks = (clientId: string) => {
  const [tasks, setTasks] = useState<Tasking[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [projectMap, setProjectMap] = useState<Record<string, string>>({});
    const empToken = useAuthToken();

  const fetchClientTasks = async () => {
    setLoading(true);
    setError(null);
    try {
      const projects = await getAllProjects();
      if (!projects) {
        throw new Error("Failed to fetch projects");
      }

      const relatedProjects = projects.filter(
        (project: ProjectAPIResponse) => project.client_id === clientId
      );

      const allTasks: Tasking[] = [];
      const nameMap: Record<string, string> = {};

      for (const project of relatedProjects) {
        const projectTasks = await getTasksByProjectId(empToken,project.project_id);
        allTasks.push(...projectTasks);
        nameMap[project.project_id] = project.project_name;
      }

      setTasks(allTasks);
      setProjectMap(nameMap);
    } catch (err) {
      console.error("Failed to fetch client tasks", err);
      setError("Failed to fetch client tasks");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (clientId) {
      fetchClientTasks();
    }
  }, [clientId]);

  return {
    tasks,
    loading,
    error,
    refreshTasks: fetchClientTasks,
    projectMap,
  };
};
